<template>
  <button
    aria-label="Open Search"
    class="open-search-modal"
    @click="$emit('open-modal')"
  >
    <span class="text">
      What's on your mind?
    </span>
    <i
      class="icon-sm icon-reg icon-search"
      aria-hidden="true"
    />
  </button>
</template>

<script>
export default {
  emits: {
    'open-modal': null,
  },
};
</script>
